module.exports = __webpack_public_path__ + "img/freedom.196d6db9.png";